import { Cookies } from 'react-cookie';

import { UpdateProfileData } from './type';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const updateProfile = async (data: UpdateProfileData) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');

  const formData = new FormData();
  formData.append('first_name', data.first_name);
  formData.append('last_name', data.last_name);
  formData.append('phone_number', data.phone_number);
  formData.append('email', data.email);
  formData.append('dob', data.dob);
  formData.append('experience', data.experience?.toString() || '');

  // Only append avatar if a new file is provided
  if (data.avatar instanceof File) {
    formData.append('avatar', data.avatar);
  }

  const response = await axiosInterceptor.patch('/user/update/', formData, {
    headers: {
      Authorization: token,
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};
